module.exports = __webpack_public_path__ + "img/firewall.9b20994.png";